module.exports = __webpack_public_path__ + "static/technology-inset-photo-d0a2b982e9504e1fe25baae6ed378ec7.jpg";